import { FunctionComponent } from 'react';
import { usePagination } from '@starjack/shared-components';
import { Voucher } from '@/models/order';
import { Box, Typography } from '@mui/material';
import { StarjackTable } from '@/components/Table/v2/Table';
import { getMoneyAsString } from '@/utils';
import { format } from 'date-fns';
import { DATE_FORMAT } from '@/constants';

type OrderDetailsVouchersTableProps = {
    vouchers: Voucher[];
};

export const OrderDetailsVouchersTable: FunctionComponent<
    OrderDetailsVouchersTableProps
> = ({ vouchers }) => {
    const {
        currentItems: currentVouchers,
        itemsPerPage: vouchersPerPage,
        setNextPage: setVoucherPage,
        countTotal,
        page,
        setItemsPerPage,
    } = usePagination({
        items: vouchers,
        itemsPerPage: 10,
    });

    return (
        <Box>
            <Typography
                sx={{
                    mb: 4,
                }}
                variant='h5'
            >
                Gutscheine
            </Typography>

            <StarjackTable<Voucher>
                currentPage={page}
                count={countTotal}
                items={currentVouchers}
                onPageChange={setVoucherPage}
                rowsPerPage={vouchersPerPage}
                onRowsPerPageChange={setItemsPerPage}
                itemId='id'
                columns={[
                    {
                        label: 'Interne ID',
                        itemKey: 'id',
                    },
                    {
                        label: 'Preis',
                        itemTransform: (voucher) =>
                            getMoneyAsString(voucher.price),
                    },
                    {
                        label: 'Titel',
                        itemKey: 'title',
                    },
                    {
                        label: 'Status',
                        itemKey: 'status',
                    },
                    {
                        label: 'Einlösezeitpunkt',
                        itemTransform: (voucher) =>
                            voucher.redemptionDate
                                ? format(voucher.redemptionDate, DATE_FORMAT)
                                : '-',
                    },
                ]}
            />
        </Box>
    );
};
